import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { deleteOrderNote } from "../../api/apiOrders";
import parseError from "../../utils/parseError";

export const useDeleteOrderNote = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteOrderNoteMutate, isPending: isDeletingNote } = useMutation({
        mutationFn: ({ id, noteId }) => deleteOrderNote(id, noteId),
        onSuccess: (res) => {
            toast.success(res.message || "Note deleted");
            queryClient.invalidateQueries(["order-notes"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to delete note");
        },
    });

    return { deleteOrderNoteMutate, isDeletingNote };
};
